import React, { useEffect, useRef, useState } from 'react'
import { Container, Input, Button, Image } from 'semantic-ui-react'
import NotificationContainer from 'react-notifications/lib/NotificationContainer';
import NotificationManager from 'react-notifications/lib/NotificationManager';
import ChangeDefaultPw from '../Ashish/ChangeDefaultPw';
import { encryptData } from './cryptoUtil';
const axios = require('axios');

function pickEmail(rec) {
    if (!rec) return '';
    // Case- and underscore-insensitive lookup so OfficialEmail/official_email,
    // EmailId/email_id, etc. all match.
    const norm = {};
    Object.keys(rec).forEach((k) => { norm[k.toLowerCase().replace(/_/g, '')] = rec[k]; });

    const order = ['officialemail', 'useremail', 'emailid', 'loginid'];
    for (let i = 0; i < order.length; i++) {
        const v = norm[order[i]];
        if (v != null && String(v).trim() !== '' && String(v).indexOf('@') > 0) {
            return String(v).trim();
        }
    }
    return '';
}

function maskEmail(email) {
    if (!email) return '';
    const at = email.indexOf('@');
    if (at <= 1) return email;
    const name = email.substring(0, at);
    const domain = email.substring(at);
    const stars = '*'.repeat(Math.min(name.length - 1, 4));
    return name[0] + stars + domain;
}

function formatMMSS(total) {
    const m = Math.floor(total / 60);
    const s = total % 60;
    return (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
}

const OTP_LENGTH = 6;
const OTP_DURATION = 180;

const Login = (props) => {

    const [loading, set_loading] = React.useState(false)
    const [id, set_id] = React.useState('')
    const [pwd, set_pwd] = React.useState('')

    // ── OTP step state ───────────────────────────────────────────────
    const [step, setStep] = useState('login'); // 'login' | 'otp'
    const [otpDigits, setOtpDigits] = useState(Array(OTP_LENGTH).fill(''));
    const [secondsLeft, setSecondsLeft] = useState(OTP_DURATION);
    const [pendingEmpData, setPendingEmpData] = useState(null);
    const [maskedEmail, setMaskedEmail] = useState('');
    const [otpMsg, setOtpMsg] = useState(null); // { text, type: 'success'|'error'|'info' }
    const [verifying, setVerifying] = useState(false);
    const [resending, setResending] = useState(false);
    const [shake, setShake] = useState(false);

    const otpRefs = useRef([]);

    // ── Countdown ────────────────────────────────────────────────────
    useEffect(() => {
        if (step !== 'otp') return;
        if (secondsLeft <= 0) return;
        const t = setInterval(() => setSecondsLeft((s) => (s > 0 ? s - 1 : 0)), 1000);
        return () => clearInterval(t);
    }, [step, secondsLeft]);

    // "Email my password" is not needed on the email+OTP login screen (there's
    // no password field to justify it), kept here commented out rather than
    // deleted in case it's wanted back.
    // const EmailMyPassword = () => {
    //     const enteredName = prompt('Please enter your email')
    //     if (enteredName != null && enteredName.trim().length != 0) MailPassword(enteredName.trim())
    //     else alert('Invalid Email')
    // }
    //
    // function MailPassword(Tomail) {
    //     if (Tomail != '' || Tomail != null) {
    //         axios.get('Nishant/FGTAPI/EmailPassword?id=' + Tomail).then(function (response) {
    //             set_loading(false)
    //             if (!response.data.Ok) NotificationManager.error('Invalid Email')
    //             else NotificationManager.success('Password Successfully sent to your mail')
    //         }).catch(function (error) {
    //             set_loading(false)
    //             alert(error);
    //         })
    //     }
    // }

    // ── Final login completion (runs only after OTP success) ─────────
    function completeLogin(empDataArr) {
        props.passChildData(empDataArr);
        const rec = empDataArr[0];
        const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/;
        if (!passwordRegex.test(pwd) && rec.IsFreelancer == "1") {
            window.location.href = window.location.origin + '/ChangeDPW';
            return;
        }
        if (rec.role_id == 22) {
            const encryptedID = encryptData(id);
            const encryptedPassword = encryptData(pwd);
            window.location.href =
                'https://rms.koenig-solutions.com/Login.aspx?ui=' + encryptedID + '&' + encryptedPassword;
            return;
        }
        window.location.href = window.location.origin + '/Outstanding_Policy';
    }

    // ── Step 1 : email → resolve creds (usp_GetUserLoginByEmail + rms_login) → send OTP ──
    function submit() {
        if (!id) {
            alert('Please enter your email');
            return;
        }
        set_loading(true)
        axios.get('yusuf/rms_login_by_email?email=' + encodeURIComponent(id))
            .then(function (response) {
                if (response.data != "" && response.data[0] && response.data[0].Blacklist != "1") {
                    const rec = response.data[0];
                    // rec.login_id / rec.pwd are the account's real UserLoginId/
                    // UserPassword resolved server-side from the email — needed
                    // later by completeLogin() (freelancer check + legacy redirect).
                    set_id(rec.login_id);
                    set_pwd(rec.pwd);
                    const email = pickEmail(rec);
                    const userId = rec.UserId != null ? rec.UserId : rec.user_id;
                    if (!email) {
                        set_loading(false);
                        alert('No registered email found for OTP. Please contact RMS.');
                        return;
                    }
                    if (userId == null || userId === '') {
                        set_loading(false);
                        alert('User account is missing UserId. Please contact RMS.');
                        return;
                    }
                    axios.post('yusuf/otp_send', {
                        userId: userId,
                        email: email,
                        name: rec.UserName || rec.Name || '',
                    })
                        .then(function (r) {
                            set_loading(false);
                            if (r.data && r.data.success) {
                                setPendingEmpData(response.data);
                                setMaskedEmail(maskEmail(email));
                                setOtpDigits(Array(OTP_LENGTH).fill(''));
                                setSecondsLeft(OTP_DURATION);
                                setOtpMsg(null);
                                setStep('otp');
                                setTimeout(() => {
                                    if (otpRefs.current[0]) otpRefs.current[0].focus();
                                }, 50);
                            } else {
                                alert((r.data && r.data.message) || 'Failed to send OTP. Please try again.');
                            }
                        })
                        .catch(function () {
                            set_loading(false);
                            alert('Failed to send OTP. Please try again.');
                        });
                }
                else if (response.data != "" && response.data[0] && response.data[0].Blacklist != "0") {
                    set_loading(false)
                    alert('Please note you do not have access to RMS.Please contact your respective Coordinator from Koenig Solutions.')
                }
                else {
                    set_loading(false)
                    alert('No RMS account found for this email.')
                }
            })
            .catch(function (error) {
                set_loading(false)
                alert(error);
            })
    }

    // ── Step 2 : OTP digit handlers ──────────────────────────────────
    function setDigit(idx, val) {
        setOtpDigits((cur) => {
            const next = cur.slice();
            next[idx] = val;
            return next;
        });
    }

    function handleOtpInput(idx, e) {
        const raw = (e.target.value || '').replace(/\D/g, '');
        if (raw.length === 0) {
            setDigit(idx, '');
            return;
        }
        if (raw.length === 1) {
            setDigit(idx, raw);
            if (idx < OTP_LENGTH - 1 && otpRefs.current[idx + 1]) otpRefs.current[idx + 1].focus();
            return;
        }
        // Multi-char (paste-via-input fallback)
        setOtpDigits((cur) => {
            const next = cur.slice();
            for (let i = 0; i < raw.length && idx + i < OTP_LENGTH; i++) {
                next[idx + i] = raw[i];
            }
            return next;
        });
        const last = Math.min(idx + raw.length, OTP_LENGTH - 1);
        if (otpRefs.current[last]) otpRefs.current[last].focus();
    }

    function handleOtpKeyDown(idx, e) {
        if (e.key === 'Backspace') {
            if (!otpDigits[idx] && idx > 0) {
                e.preventDefault();
                setDigit(idx - 1, '');
                if (otpRefs.current[idx - 1]) otpRefs.current[idx - 1].focus();
            } else if (otpDigits[idx]) {
                e.preventDefault();
                setDigit(idx, '');
            }
        } else if (e.key === 'ArrowLeft' && idx > 0) {
            e.preventDefault();
            otpRefs.current[idx - 1].focus();
        } else if (e.key === 'ArrowRight' && idx < OTP_LENGTH - 1) {
            e.preventDefault();
            otpRefs.current[idx + 1].focus();
        } else if (e.key === 'Enter') {
            verifyOtp();
        } else if (!/^[0-9]$/.test(e.key) && !['Tab', 'Shift', 'Meta', 'Control', 'Alt'].includes(e.key)) {
            // block non-digit, non-control keys
            e.preventDefault();
        }
    }

    function handleOtpPaste(idx, e) {
        e.preventDefault();
        const txt = (e.clipboardData || window.clipboardData).getData('text') || '';
        const digits = txt.replace(/\D/g, '').substring(0, OTP_LENGTH);
        if (!digits.length) return;
        setOtpDigits((cur) => {
            const next = cur.slice();
            for (let i = 0; i < digits.length && idx + i < OTP_LENGTH; i++) {
                next[idx + i] = digits[i];
            }
            return next;
        });
        const last = Math.min(idx + digits.length, OTP_LENGTH - 1);
        if (otpRefs.current[last]) otpRefs.current[last].focus();
    }

    function verifyOtp() {
        const otp = otpDigits.join('');
        if (otp.length < OTP_LENGTH) {
            setOtpMsg({ text: 'Please enter all 6 digits.', type: 'error' });
            const firstEmpty = otpDigits.findIndex((d) => !d);
            if (firstEmpty >= 0 && otpRefs.current[firstEmpty]) otpRefs.current[firstEmpty].focus();
            return;
        }
        if (!pendingEmpData) return;
        const rec = pendingEmpData[0];
        const userId = rec.UserId != null ? rec.UserId : rec.user_id;
        setVerifying(true);
        axios.post('yusuf/otp_verify', {
            userId: userId,
            otp: otp,
        })
            .then(function (r) {
                const d = r.data || {};
                if (d.success) {
                    setOtpMsg({ text: 'Verified! Redirecting…', type: 'success' });
                    setTimeout(() => completeLogin(pendingEmpData), 600);
                    return;
                }
                setVerifying(false);
                setOtpMsg({ text: d.message || 'Verification failed.', type: 'error' });
                setShake(true);
                setTimeout(() => setShake(false), 500);
                if (d.status === -1 || d.status === -3) {
                    setSecondsLeft(0);
                }
            })
            .catch(function () {
                setVerifying(false);
                setOtpMsg({ text: 'Connection error. Please try again.', type: 'error' });
            });
    }

    function resendOtp() {
        if (!pendingEmpData) return;
        const rec = pendingEmpData[0];
        const email = pickEmail(rec);
        const userId = rec.UserId != null ? rec.UserId : rec.user_id;
        setResending(true);
        axios.post('yusuf/otp_resend', {
            userId: userId,
            email: email,
            name: rec.UserName || rec.Name || '',
        })
            .then(function (r) {
                setResending(false);
                if (r.data && r.data.success) {
                    setOtpDigits(Array(OTP_LENGTH).fill(''));
                    setSecondsLeft(OTP_DURATION);
                    setOtpMsg({ text: 'New OTP sent to your email.', type: 'info' });
                    if (otpRefs.current[0]) otpRefs.current[0].focus();
                } else {
                    setOtpMsg({ text: (r.data && r.data.message) || 'Failed to resend OTP.', type: 'error' });
                }
            })
            .catch(function () {
                setResending(false);
                setOtpMsg({ text: 'Connection error. Please try again.', type: 'error' });
            });
    }

    function backToLogin() {
        setStep('login');
        setOtpDigits(Array(OTP_LENGTH).fill(''));
        setOtpMsg(null);
        setSecondsLeft(OTP_DURATION);
        setPendingEmpData(null);
        setVerifying(false);
    }

    // ── Render: login step ───────────────────────────────────────────
    const renderLoginStep = () => (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#fff',
            width: 600,
            paddingLeft: 130, paddingRight: 130,
            height: '100vh'
        }}>
            <br /><br />
            <Image
                style={{ alignSelf: 'center', height: 100, width: 100 }}
                src={require('./images/ko.png')} />
            <br /><br /><br /><br /><br />
            <Input
                onChange={(e) => { set_id(e.target.value) }}
                size='large' placeholder='Your Official Email' />
            <br />
            {/* Password field removed — this screen is email + OTP only now.
                See the commented-out EmailMyPassword()/MailPassword() above and
                the <a> link below for the prior username/password screen. */}
            {/* <a href="javascript:void(0)" onClick={() => EmailMyPassword()}>Email my password</a>
            <br /> */}
            <div style={{ alignSelf: 'center', display: loading ? 'none' : 'flex' }}>
                <Button
                    style={{ width: 340, fontSize: 16 }}
                    onClick={() => submit()} positive>Send OTP</Button>
            </div>
            <div style={{ alignSelf: 'center', display: loading ? 'flex' : 'none' }}>
                <Button style={{ width: 340, fontSize: 16 }} loading positive>Loading</Button>
            </div>
        </div>
    );

    // ── Render: OTP step ─────────────────────────────────────────────
    const expiringSoon = secondsLeft > 0 && secondsLeft <= 60;
    const expired = secondsLeft <= 0;
    const resendDisabled = resending || (!expired && secondsLeft > 0);

    const digitStyle = (val) => ({
        width: 48, height: 56,
        border: '2px solid ' + (val ? '#2563eb' : '#e2e8f0'),
        borderRadius: 10,
        textAlign: 'center',
        fontSize: 28, fontWeight: 800,
        fontFamily: 'Arial, Helvetica, sans-serif',
        color: '#000', background: '#fff',
        outline: 'none', padding: 0,
        animation: shake ? 'rms-otp-shake 0.4s' : 'none',
    });

    const msgStyle = otpMsg && {
        padding: '9px 14px', borderRadius: 8, fontSize: 13, marginBottom: 14, textAlign: 'left',
        background: otpMsg.type === 'success' ? '#f0fdf4' : otpMsg.type === 'error' ? '#fff5f5' : '#eff6ff',
        color: otpMsg.type === 'success' ? '#16a34a' : otpMsg.type === 'error' ? '#dc2626' : '#2563eb',
        border: '1px solid ' + (otpMsg.type === 'success' ? '#bbf7d0' : otpMsg.type === 'error' ? '#fecaca' : '#bfdbfe'),
    };

    const renderOtpStep = () => (
        <div style={{
            display: 'flex', flexDirection: 'column', backgroundColor: '#fff',
            width: 600, paddingLeft: 130, paddingRight: 130, height: '100vh',
        }}>
            <style>{`
                @keyframes rms-otp-shake {
                    0%,100% { transform: translateX(0); }
                    20%      { transform: translateX(-5px); }
                    60%      { transform: translateX(5px); }
                }
                @keyframes rms-otp-fade {
                    from { opacity: 0; transform: translateY(18px); }
                    to   { opacity: 1; transform: translateY(0); }
                }
            `}</style>
            <br /><br />
            <Image
                style={{ alignSelf: 'center', height: 100, width: 100 }}
                src={require('./images/ko.png')} />
            <div style={{ textAlign: 'center', paddingTop: 20, animation: 'rms-otp-fade 0.35s ease' }}>
                <div style={{
                    width: 72, height: 72, background: '#eff6ff', borderRadius: '50%',
                    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                    margin: '0 auto 18px auto', boxShadow: '0 2px 12px rgba(37,99,235,0.12)',
                }}>
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#2563eb"
                        strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                        <polyline points="9 12 11 14 15 10" />
                    </svg>
                </div>
                <h3 style={{ fontSize: 21, fontWeight: 700, color: '#1e293b', marginBottom: 6 }}>
                    Verify Your Identity
                </h3>
                <p style={{ color: '#64748b', fontSize: 13.5, marginBottom: 3 }}>
                    We've sent a 6-digit code to
                </p>
                <p style={{ color: '#2563eb', fontSize: 14, fontWeight: 600, marginBottom: 26 }}>
                    {maskedEmail || ' '}
                </p>

                <div style={{ display: 'flex', gap: 9, justifyContent: 'center', marginBottom: 18 }}>
                    {otpDigits.map((d, i) => (
                        <input
                            key={i}
                            ref={(el) => (otpRefs.current[i] = el)}
                            type="tel"
                            inputMode="numeric"
                            pattern="[0-9]"
                            maxLength={1}
                            value={d}
                            onChange={(e) => handleOtpInput(i, e)}
                            onKeyDown={(e) => handleOtpKeyDown(i, e)}
                            onPaste={(e) => handleOtpPaste(i, e)}
                            autoComplete="off"
                            autoCorrect="off"
                            autoCapitalize="off"
                            spellCheck="false"
                            style={digitStyle(d)}
                        />
                    ))}
                </div>

                <div style={{ fontSize: 13, color: '#94a3b8', marginBottom: 14 }}>
                    {expired ? (
                        <span style={{ fontWeight: 700, color: '#ef4444' }}>Expired</span>
                    ) : (
                        <>
                            Expires in&nbsp;
                            <span style={{
                                fontWeight: 700,
                                color: expiringSoon ? '#ef4444' : '#2563eb',
                                marginLeft: 4,
                            }}>{formatMMSS(secondsLeft)}</span>
                        </>
                    )}
                </div>

                {otpMsg && <div style={msgStyle}>{otpMsg.text}</div>}

                <button
                    type="button"
                    onClick={verifyOtp}
                    disabled={verifying}
                    style={{
                        width: '100%', padding: 13,
                        background: '#2563eb', color: '#fff',
                        border: 'none', borderRadius: 10,
                        fontSize: 15, fontWeight: 600,
                        cursor: verifying ? 'not-allowed' : 'pointer',
                        marginBottom: 14, letterSpacing: '.3px',
                        opacity: verifying ? 0.65 : 1,
                    }}>
                    {verifying ? 'Verifying…' : 'Verify OTP'}
                </button>

                <div style={{ fontSize: 13, color: '#94a3b8', marginBottom: 10 }}>
                    Didn't receive the code?&nbsp;
                    <button
                        type="button"
                        onClick={resendOtp}
                        disabled={resendDisabled}
                        style={{
                            background: 'none', border: 'none',
                            color: resendDisabled ? '#94a3b8' : '#2563eb',
                            fontSize: 13, fontWeight: 600,
                            cursor: resendDisabled ? 'not-allowed' : 'pointer',
                            padding: '0 3px',
                            textDecoration: resendDisabled ? 'none' : 'underline',
                        }}>
                        {resending ? 'Sending…' : 'Resend OTP'}
                    </button>
                </div>

                <div>
                    <button
                        type="button"
                        onClick={backToLogin}
                        style={{
                            background: 'none', border: 'none',
                            color: '#64748b', fontSize: 13,
                            cursor: 'pointer', padding: '4px 8px', borderRadius: 6,
                        }}>
                        ← Back to Login
                    </button>
                </div>
            </div>
        </div>
    );

    return (
        <Container style={{ width: 600, backgroundColor: '#fff' }}>
            {step === 'login' ? renderLoginStep() : renderOtpStep()}
            <NotificationContainer></NotificationContainer>
        </Container>
    )
}

export default Login
